import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { LogOut } from "lucide-react";
import LocationModal from "../LocationModal/LocationModal";

const Navbar = ({  isAuthenticated, onLogout , userData: propUserData, onLoginHover }) => {
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [userData, setUserData] = useState(propUserData || null);

  const userDropdownRef = useRef(null);
  const navbarCollapseRef = useRef(null);

  // Show tabs always (trial restriction removed)
  const showTabs = true;
  // Update userData when propUserData changes
  useEffect(() => {
    if (propUserData) {
      setUserData(propUserData);
    } else {
      // Clear user data when logged out
      setUserData(null);
    }
  }, [propUserData]);

   // Keep the existing localStorage sync for cross-tab updates
   useEffect(() => {
    const getUserData = () => {
      const user = localStorage.getItem('xlent_user');
      if (user) {
        try {
          setUserData(JSON.parse(user));
        } catch (error) {
          console.error('Error parsing user data:', error);
        }
      } else {
        setUserData(null);
      }
    };
    
    getUserData();
    
    const handleStorageChange = (e) => {
      if (e.key === 'xlent_user') {
        getUserData();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close navbar menu on link click
  const closeMenu = () => {
    setShowUserDropdown(false);
    
    // Also close Bootstrap's collapse
    const navbarCollapse = navbarCollapseRef.current;
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      const toggleButton = document.querySelector('[data-bs-target="#navbarSupportedContent"]');
      if (toggleButton) {
        toggleButton.click();
      }
    }
  };

  const handleLogout = () => {
     {
      onLogout();
      localStorage.removeItem('xlent_token');
      localStorage.removeItem('xlent_user');
    } 
    closeMenu();
  };

  return (
    <>
      <nav 
        className="navbar navbar-expand-lg navbar-light fixed-top navbar-custom" 
        style={{
          zIndex: 1111
        }}
      >
        <div className="container-fluid px-3 px-md-5">
          {/* Brand on the left corner */}
          <Link className="navbar-brand d-flex align-items-center" to="/" style={{ color: 'white' }}>
            <img src="/XlentCar-logo-without-bg.png" alt="xlentcar Icon" className="d-inline-block align-text-top" />
            {/* <span className="ms-2 fw-bolder navbar-brand-text">Xlentcar</span> */}
          </Link>

          <button
            className="navbar-toggler navbar-toggler-custom"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ borderColor: 'rgba(255, 255, 255, 0.5)' }}
          >
            <span className="navbar-toggler-icon" style={{ filter: 'invert(1)' }}></span>
          </button>

          <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent" ref={navbarCollapseRef}>
            <ul className="navbar-nav navbar-nav-custom">
              {/* Show these tabs when authenticated */}
              {showTabs && (
                <>
                  
                  <li className="nav-item dropdown">
                    <a 
                      className="nav-link dropdown-toggle nav-link-custom" 
                      onClick={() => setShowLocationModal(true)}

                      style={{ 
                        cursor: 'pointer',
                        color: 'white'
                      }}
                    >
                      Locations
                    </a>
                  
                  </li>

                  <li className="nav-item">
                    <Link to="/deals" onClick={closeMenu} className="nav-link nav-link-custom"  style={{ color: 'white' }}>
                      Special Deals
                    </Link>
                  </li>

                  {isAuthenticated && (<>
                    <li className="nav-item">
                      <Link to="/add-car" onClick={closeMenu} className="nav-link nav-link-custom"  style={{ color: 'white' }}>
                        Add Car
                      </Link>
                    </li>
                    <li className="nav-item">
                    <Link to="/customer-dashboard" onClick={closeMenu} className="nav-link nav-link-custom"  style={{ color: 'white' }}>
                      Admin Dashboard
                    </Link>
                  </li>
                    <li className="nav-item">
                    <Link to="/BookingDashboard" onClick={closeMenu} className="nav-link nav-link-custom"  style={{ color: 'white' }}>
                    Booking Dashboard
                    </Link>
                  </li>
                  </>
                  )}

                  <li className="nav-item">
                    <Link to='/about' onClick={closeMenu} className="nav-link nav-link-custom"  style={{ color: 'white' }}>
                      About Us
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/HelpCenter" onClick={closeMenu} className="nav-link nav-link-custom" style={{ color: 'white' }}>
                      HelpCenter
                    </Link>
                  </li>
                </>
              )}

              {/* User Dropdown - Shows when authenticated */}
              {isAuthenticated ? (
                <li className="nav-item dropdown ms-2" ref={userDropdownRef}>
                  <button
                    className="btn d-flex align-items-center p-2 nav-link-custom"
                    onClick={() => setShowUserDropdown(!showUserDropdown)}
                    style={{
                      background: 'transparent',
                      color: 'white',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      borderRadius: '50px',
                      fontWeight: '600',
                      fontSize: '0.9rem',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      padding: '0.5rem 1rem'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'transparent';
                      e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                    }}
                  >
                    <div className="rounded-circle bg-white text-primary d-flex align-items-center justify-content-center me-2" 
                         style={{ width: '28px', height: '28px', fontSize: '0.8rem', fontWeight: 'bold' }}>
                      {userData?.name?.charAt(0).toUpperCase() || 'U'}
                    </div>
                    <span>{userData?.name?.split(' ')[0] || 'User'}</span>
                    <i className={`bi bi-chevron-down ms-2 ${showUserDropdown ? 'rotate-180' : ''}`} 
                       style={{ transition: 'transform 0.3s ease' }}></i>
                  </button>
                  
                  {showUserDropdown && (
                    <div 
                      className="dropdown-menu show dropdown-menu-custom1"
                      style={{
                        position: 'absolute',
                        right: 0,
                        left: 'auto',
                        backgroundColor: 'white',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                        minWidth: '200px',
                        padding: '0.5rem 0'
                      }}
                    >
                      <div className="px-3 py-2 border-bottom">
                        <div className="small text-muted">Signed in as</div>
                        <div className="fw-semibold text-truncate">{userData?.name || 'user@example.com'}</div>
                      </div>
                  
                      
                    
                      
                      <button 
                        className="dropdown-item dropdown-item-custom d-flex align-items-center text-danger"
                        onClick={handleLogout}
                      >
                        <LogOut size={16} className="me-2" />
                        Logout
                      </button>
                    </div>
                  )}
                </li>
              ) : (
                // Login & Register buttons - Shows when NOT authenticated
                <>
                  <li className="nav-item nav-button-item">
                    <button 
                      className="btn login-btn nav-btn-custom"
                      style={{
                        background: 'transparent',
                        color: 'white',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        borderRadius: '25px',
                        fontWeight: '600',
                        fontSize: '0.9rem',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = 'transparent';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                      }}
                    >
                      <Link to="/login" onClick={closeMenu}  onMouseEnter={onLoginHover} style={{ color: 'white', textDecoration: 'none' }}>
                        Login
                      </Link>
                    </button>
                  </li>

                  {/* <li className="nav-item nav-button-item">
                    <button 
                      className="btn signup-btn nav-btn-custom"
                      style={{
                        background: '#ff6b35',
                        color: 'white',
                        border: 'none',
                        borderRadius: '25px',
                        padding: '0.5rem 1.5rem',
                        fontWeight: '600',
                        fontSize: '0.9rem',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = '#e55a2b';
                        e.target.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = '#ff6b35';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      <Link to="/register" onClick={closeMenu} style={{ color: 'white', textDecoration: 'none' }}>
                        Register
                      </Link>
                    </button>
                  </li> */}
             
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
      <LocationModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        onSelectLocation={(city) => {
          console.log('Selected city:', city);
          // Save to state, localStorage, or whatever you need
        }}
      />
    
    </>
  );
};

export default Navbar;